module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="sorting-panel-region"></div>\n<div class="content collection experience-thumbnails"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/publish/PublishToolbarThumbnailView.tpl
// module id = 3139
// module chunks = 0